module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en-us":{"sectionTitle":"Add to your website","sectionDescription":"Use a javascript snippet to place this landing page on your website.","copyCodeButtonLabel":"Copy code"}}')
  delete Component.options._Ctor
}
